module.exports = __webpack_public_path__ + "img/wa-not-hover-en.e0805f64.png";